import { Divider, Form, Input, Spin, Table } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { save } from "../../../../features/save/saveSlice";
import svg44 from "../../../../assets/svg/svg44.svg";
import svg45 from "../../../../assets/svg/svg45.svg";
import svg46 from "../../../../assets/svg/svg46.svg";
import svg40 from "../../../../assets/svg/svg40.svg";
import toast from "react-hot-toast";
import {
  fetchData,
  fetchFiles, 
} from "../../../../features/fetch/fetchSlice";
import useModalToggle from "../../../../custom_hooks/useModalToggle";
import DocumentAdd from "./DocumentAdd";
import ConfirmModal from "../../../../components/ConfirmModal";
import moment from "moment";
import BreadCrumb from "../../../../layout/BreadCrumb";

const { TextArea } = Input;
function ByLaws({ handleNext, handleBack }) {
  const { open, handleCancel, handleOpen } = useModalToggle();
  const url = "api/v2/projectFiles/get";
  const urlSingle = "api/v2/main_projects/get";
  const { saving } = useSelector((state) => state.save);
  const { loading, data, count, activeObjPlannedProject, dataProjSingle } =
    useSelector((state) => ({
      loading: state.fetch.loading,
      data: state.fetch.data[url] || [],
      count: state.fetch.count[url] || 0,
      activeObjPlannedProject: state.obj.activeObj["plannedProject"],
      dataProjSingle: state.fetch.data[urlSingle] || [],
    }));

  const [form] = Form.useForm();
  const formRef = useRef(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [prodd, setProdd] = useState();
  const [prodd1, setProdd1] = useState();

  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleDelete = async () => {
    const res = await dispatch(
      save({
        url: "api/v2/projectFiles/delete",
        pfId: prodd?.pfId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await setOpenDelete(false);
      await fetchTableData();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const handleOpenDocAtt = async (item) => {
    await setProdd1(item);
    await handleOpen();
  };

  const downloadFile = async (item) => {
    try {
      const res = await dispatch(fetchFiles({ file: item }));
      if (res?.payload) {
        window.open(res.payload, "_blank");
      }
    } catch (error) {
      console.error("Failed to open file:", error);
    }
  };

  const columns = [
    {
      title: "Uploaded Documents",
      dataIndex: "pfFileName",
      render: (item) => {
        return (
          <div className="cursor-pointer flex items-center gap-x-[.65rem]">
            {" "}
            <img src={svg44} alt="svg44" /> {item}
          </div>
        );
      },
    },

    {
      title: "Uploaded Date",
      dataIndex: "damStartDate",
      render: (text) => (text ? moment(text).format("DD-MM-YYYY") : "--"), 
    },

    {
      title: (
        <div
          className="p-[.5rem] w-auto gap-[.5rem] h-[2rem] flex items-center justify-center rounded-[0.375rem] border border-[#D6E1F5] bg-white cursor-pointer"
          onClick={() => handleOpen()}
        >
          <img src={svg40} alt="svg40" /> Upload
        </div>
      ), 
      width:'150px',
      align: "right",
      render: (item) => {
        return (
          <div
            className="flex items-center gap-x-[.62rem]"
            onClick={() => setProdd(item)}
          >
            <img
              src={svg45}
              alt="svg45"
              className="cursor-pointer"
              onClick={() => downloadFile(item?.pfFilePath)}
            />
            <img
              className="cursor-pointer"
              src={svg46}
              alt="svg46"
              onClick={() => handleOpenDelete()}
            />
          </div>
        );
      },
    },
  ];

  const handlePrev = () => {
    handleBack();
  };

  const onFinish = async (data) => {
    const res = await dispatch(
      save({
        projectId: activeObjPlannedProject?.projectId,
        url: "api/v2/main_projects/save",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await handleNext();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        pfFileCategory: "LICENCING",
        pfProjectId: activeObjPlannedProject?.projectId,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  async function fetchProjData() {
    await dispatch(
      fetchData({
        url: urlSingle,
        projectId: activeObjPlannedProject?.projectId,
        limit: null,
        start: 0,
      })
    );
  }

  useEffect(() => {
    fetchTableData();
    fetchProjData(); 
  }, []);

  return (
    <>
     <BreadCrumb breadcrumbs={[{ title: "ByLaws" }]} />
      <div className="flex  flex-col gap-[1.25rem] mt-[1.25rem]  min-h-[80vh] white_card">
        <div className="form-add-h">
        Bylaws
        </div>
        <div className="w-full">
          <Table
            rowSelection={false}
            className="w-full mt-[1.25rem]"
            scroll={{
              x: "auto",
            }}
            rowKey={(record) => record?.pfId}
            columns={columns}
            dataSource={data}
            loading={loading}
            pagination={{
              position: ["bottomRight"],
              current: pageIndex + 1,
              total: count,
              pageSize: pageSize,
              onChange: (page, size) => {
                setPageIndex(page - 1);
                setPageSize(size);
                fetchTableData(page - 1, size);
              },
              showSizeChanger: false,
              hideOnSinglePage: true,
            }}
          />
        </div>
      </div>
    

      <DocumentAdd
        isModalOpen={open}
        handleCancel={handleCancel}
        handleFetch={fetchTableData}
        prodd={prodd}
        prodd1={prodd1}
      />

      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={loading}
        content="Are you sure you want perfom this action?"
        type="alert"
        btnTitle="Delete"
      />
    </>
  );
}

export default ByLaws;
